import type { ReactNode } from 'react';
import ModuleLayout, { type BreadcrumbItem, type ModuleMetric } from '@/components/admin/ModuleLayout';
import { EntityDetailNavLayout, type EntityDetailNavGroup } from '@/components/admin/EntityDetailNav';
import { traNavTabs } from './traNavTabs';

export type EditionTabKey = 'info' | 'participantes' | 'configuracion';

const EDITION_TAB_LABELS: Record<EditionTabKey, string> = {
  info: 'Información',
  participantes: 'Participantes',
  configuracion: 'Configuración',
};

interface EditionShellProps {
  mode: 'create' | 'edit';
  activeTab: EditionTabKey;
  onTabChange: (tab: EditionTabKey) => void;
  breadcrumbs: BreadcrumbItem[];
  title: string;
  subtitle: string;
  metrics?: ModuleMetric[];
  headerActions?: ReactNode;
  children: ReactNode;
}

// Shell de detalle por edición de certificación Tripoli, calcado de RegionalShell
// (CCCD) — mismo contrato de tabs bloqueados en modo creación, pero propio de TRA
// en vez de compartido entre plataformas (ver tra-edition-tabbed-detail/design.md,
// Decisión 2).
export function EditionShell({ mode, activeTab, onTabChange, breadcrumbs, title, subtitle, metrics, headerActions, children }: EditionShellProps) {
  const locked = (key: EditionTabKey) => mode === 'create' && key !== 'info';
  const groups: EntityDetailNavGroup<EditionTabKey>[] = [
    { label: 'GENERAL', items: [
      { key: 'info', label: EDITION_TAB_LABELS.info, locked: locked('info') },
      { key: 'configuracion', label: EDITION_TAB_LABELS.configuracion, locked: locked('configuracion') },
    ] },
    { label: 'COMUNIDAD', items: [
      { key: 'participantes', label: EDITION_TAB_LABELS.participantes, locked: locked('participantes') },
    ] },
  ];

  return (
    <ModuleLayout
      breadcrumbs={breadcrumbs}
      title={title}
      subtitle={subtitle}
      tabs={traNavTabs('editions')}
      metrics={metrics ?? []}
      actions={headerActions}
    >
      <EntityDetailNavLayout groups={groups} activeKey={activeTab} onChange={(key) => !locked(key) && onTabChange(key)}>
        {children}
      </EntityDetailNavLayout>
    </ModuleLayout>
  );
}
